import clsx from "clsx"
import {useState} from "react"
import {SubmitHandler, useForm} from "react-hook-form"
import Button from "~/components/UI/Button/Button"
import CheckBox from "~/components/UI/CheckBox/CheckBox"
import InputText from "~/components/UI/InputText/InputText"
import TextArea from "~/components/UI/TextArea/TextArea"
import CheckIcon from "~/icons/CheckIcon"
import {useLabelsQuery} from "~/queries/LabelsQuery"
import ErrorIcon from "../../icons/ErrorIcon"
import {useAuthenticationLabelsQuery} from "../../queries/AuthenticationLabelsQuery"
import {emailRegex, nameRegex, phoneRegex, textRegex} from "../../utilities/RegexStrings"
import "./Form.css"

interface ContactUsFormProps extends React.FormHTMLAttributes<HTMLFormElement> {}

// Se il nome dei campi è caotico, dipende dalla form.
type ContactUsFields = {
    Name_First: string
    Name_Last: string
    Email: string
    PhoneNumber_countrycode: string
    MultiLine: string
    DecisionBox: "on" | ""
}

type SubmitStatus = undefined | "success" | "error"

const ContactUsForm: React.FC<ContactUsFormProps> = props => {
    const {className, children, ...otherProps} = props
    const [submitStatus, setSubmitStatus] = useState<SubmitStatus>()

    const {
        register,
        handleSubmit,
        watch,
        formState: {errors},
    } = useForm<ContactUsFields>()
    const labels = {...useLabelsQuery(), ...useAuthenticationLabelsQuery()}

    const onFormSubmitHandler: SubmitHandler<ContactUsFields> = async inputData => {
        const data = {...inputData, PhoneNumber_countrycode: inputData.PhoneNumber_countrycode.replace("+", "00")}

        const url =
            "https://forms.zohopublic.eu/adkaora/form/AdKaoranewwebsiteLAVORACONNOI/formperma/0UrFrFIFXXh4TlYIYqqlCXQMMRyLHuAazd6AyGFit14/htmlRecords/submit"

        const formData = new FormData()

        for (const field in data) {
            type ObjectKey = keyof typeof data
            const fieldKey = field as ObjectKey
            if (typeof data[fieldKey] === "boolean") {
                const bool = data[fieldKey] as unknown as boolean
                if (bool) {
                    formData.append(field, "on")
                } else {
                    formData.append(field, "")
                }
                continue
            }
            formData.append(field, data[fieldKey])
        }

        const requestOptions: RequestInit = {
            method: "POST",
            mode: "cors",
            body: formData,
            redirect: "manual",
            cache: "no-cache",
            credentials: "same-origin",
        }

        await fetch(url, requestOptions).catch((error: Error) => {})
        setSubmitStatus("success")
    }

    return (
        <form className={clsx("form-ykf9", className)} onSubmit={handleSubmit(onFormSubmitHandler)} {...otherProps}>
            <h4 className="title-ykf9 span2-ykf9">{labels.contactUs}</h4>
            <InputText
                type="text"
                placeholder={labels.name}
                invalid={errors.Name_First !== undefined}
                {...register("Name_First", {required: true, pattern: nameRegex})}
            />
            <InputText
                type="text"
                placeholder={labels.lastName}
                invalid={errors.Name_Last !== undefined}
                {...register("Name_Last", {required: true, pattern: nameRegex})}
            />
            <InputText
                type="email"
                placeholder={labels.eMail}
                invalid={errors.Email !== undefined}
                {...register("Email", {
                    required: true,
                    pattern: emailRegex,
                })}
            />
            <div className="full-width-ykf9">
                <InputText
                    containerClassName="full-width-ykf9 phone-input-ykf9"
                    type="phone"
                    placeholder={labels.phoneNumber}
                    invalid={errors.PhoneNumber_countrycode !== undefined}
                    {...register("PhoneNumber_countrycode", {
                        required: true,
                        pattern: phoneRegex,
                    })}
                />
                {errors.PhoneNumber_countrycode !== undefined && (
                    <div className="messages-box-pt86">{labels.validationInvalidPhoneNumber}</div>
                )}
            </div>
            <TextArea
                placeholder={labels.message}
                rows={8}
                className="span2-ykf9"
                invalid={errors.MultiLine !== undefined}
                {...register("MultiLine", {required: false, pattern: textRegex})}
            />
            <CheckBox
                label={labels.privacyAcceptance}
                className="span2-ykf9"
                invalid={errors.DecisionBox !== undefined}
                {...register("DecisionBox", {required: true})}
            />
            <Button className="span2-ykf9 button-ykf9" type="submit">
                {labels.submitForm}
            </Button>
            {submitStatus === "success" && (
                <div className="overlay-ykf9 gray-ykf9">
                    <div className="modal-ykf9">
                        <CheckIcon className="check-icon-ykf9" />
                        <span className="submit-success-message-ykf9">{labels.submitSuccessMessage}</span>
                    </div>
                </div>
            )}
            {submitStatus === "error" && (
                <div className="overlay-ykf9 gray-ykf9">
                    <div className="modal-ykf9">
                        <ErrorIcon className="error-icon-ykf9" />
                        <span className="submit-success-message-ykf9">Error</span>
                    </div>
                </div>
            )}
        </form>
    )
}

export default ContactUsForm
